import React from 'react';
import { containers, Grid, TextEnterExit } from 'style';

const IframeComponent = ({ url }) => (
    <div className="wrapper" id="IframeComponent">
        <div className="container-fluid">
            <div className="row">
                <div className="col-xs-12">
                    <iframe
                        src={url}
                        style={{ width: '100%', border: 0 }}></iframe>
                </div>
            </div>
        </div>
    </div>
);

export default IframeComponent;
